<template>

  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>
  <div class="cell small-12">
    <h1>Scheme Tax Treatment</h1>
    <p>When deductions are taken from an employee, it is possible for these deductions to take place before or after tax and national insurance, depending on scheme rules.</p>
    <p>Please indicate if your scheme requires pension to be deducted prior to tax or national insurance.</p>
    </div>  
    <div class="cell small-6">
        <form class="fieldset" @submit.prevent> 
          <label class="custom-check">
            <input
              type="checkbox"
              v-model="formData.isDeductedBeforeTax"
            >Pension is deducted before tax<span class="checkmark"></span>
          </label> 
          <label class="custom-check">
            <input
              type="checkbox"
              v-model="formData.isDeductedBeforeNi"
            >Pension is deducted before national insurance<span class="checkmark"></span>
          </label> 

        </form>
    </div>



</template>


<script setup>

import { ref, onMounted } from 'vue'

const error = ref([]);

const props = defineProps({
  formData: Object
})


const validateStep = () => {

  error.value = [];



  if (error.value.length > 0) return false;

  return true;
}



const executeStep = async () => {
  return true;
}




onMounted(() => {

});

defineExpose({ validateStep, executeStep });

</script>